import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #bogosObserver;
  #bogosWasVisible = false;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.#watchBogosPopup();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.#bogosObserver?.disconnect();
  }

  #handleCartAdd = () => {
  const bogosPopupVisible = document
    .querySelector('#freegifts-main-popup-container')
    ?.classList.contains('sca-is-visible-fg');

  if (this.hasAttribute('auto-open') && !bogosPopupVisible) {
    this.showDialog();
  }
};

  #watchBogosPopup() {
    const checkPopup = () => {
      const popup = document.querySelector(
        '#freegifts-main-popup-container'
      );

      const isVisible =
        popup?.classList.contains('sca-is-visible-fg') ?? false;

      // BOGOS popup has just opened
      if (isVisible && !this.#bogosWasVisible) {
        this.#bogosWasVisible = true;
        this.closeDialog();
      }

      // BOGOS popup has just closed
      if (!isVisible && this.#bogosWasVisible) {
        this.#bogosWasVisible = false;

        // Give BOGOS time to finish updating the cart
        window.setTimeout(() => {
          this.showDialog();
        }, 500);
      }
    };

    this.#bogosObserver = new MutationObserver(checkPopup);

    this.#bogosObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    checkPopup();
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked
     * to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;

      const cta = installmentsContent?.querySelector(
        '#shopify-installments-cta'
      );

      cta?.addEventListener('click', this.closeDialog, {
        once: true,
      });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );
}